import React__default from 'react';
import { useRadioGroup } from '@mui/material';
import { FormLabelField } from '../form-label-field/index.js';
import { jsx } from 'react/jsx-runtime';

const RadioGroupLabel = props => {
  const {
    children,
    ...formLabelProps
  } = props;
  const state = useRadioGroup();
  return /*#__PURE__*/jsx(FormLabelField, {
    ...formLabelProps,
    children: React__default.Children.map(props.secondaryAction, element => {
      if (! /*#__PURE__*/React__default.isValidElement(element)) {
        return;
      }
      if (String(state?.value) === String(element.props.value)) {
        return children;
      }
    })
  });
};

export { RadioGroupLabel };
